import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
} from "@mui/material";
import { Science } from "@mui/icons-material";

const ToDate = (input) => {
  if (input) return new Date(input).toLocaleDateString();
  return "";
};

export default function Sample({ sample }) {

  const InfoRow = ({ label, value }) => (
    <Box sx={{ display: "flex", mb: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: 600, minWidth: "160px", color: "#555" }}>
        {label}:
      </Typography>
      <Typography variant="body2" sx={{ ml: 1, color: "#333" }}>
        {value || "N/A"}
      </Typography>
    </Box>
  );

  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 2,
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Science sx={{ color: "#1976d2", mr: 1, fontSize: 20 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#1976d2", mr: 1 }}>
            Lab ID:
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              color: "#1976d2",
              border: "1px solid #1976d2",
              borderRadius: "20px",
              px: 1.5,
              py: 0.2,
              fontSize: "0.8rem",
            }}
          >
            {sample.LabId}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <InfoRow label="Description" value={sample.SampleDescription} />
        <InfoRow label="Date Collected" value={ToDate(sample.DateCollected)} />
        <InfoRow label="Collected By" value={sample.CollectedBy} />
      </CardContent>
    </Card>
  );
}